/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-04-08 10:10:44
 *
 *******************************************************/
// @flow
import _ from 'lodash';

import { NUMBER_SAVED_EXECUTION_ID_GROUP, NUMBER_DAYS_ON_TOTAL } from 'src/constants/analytics';

/**
 * Build query key
 *
 * @param  {object} data
 *                     { fromDate, toDate, compare, collectionId }
 *
 * @return {string}      query key
 */
export const buildQueryKey = data => {
  const { fromDate, toDate, compare, collectionId = '', searchTerm = '' } = data;

  if (!fromDate || !toDate) return '';

  return `${fromDate.toISOString()}_${toDate.toISOString()}_${collectionId}_${searchTerm}_${compare}`;
};

export const buildTotalQueryKey = (recentDays = NUMBER_DAYS_ON_TOTAL) => {
  const now = new Date();

  return `total_${now.toISOString().slice(0, 10)}_${recentDays}`;
};

/**
 * Parse and save execution id
 *
 * @param  {object} data
 *                     { fromDate, toDate, compare, collectionId, executionIdKey, executionId }
 * @param  {array} executionIds list of execution id from others process
 *
 * @return {array}              updated list
 */
export const saveExecutionId = (data, executionIds) => {
  const { queryKey, executionIdKey, executionId } = data;

  // Find execution id index
  const index = _.findIndex(executionIds, { queryKey });

  // Existed
  if (index !== undefined && index !== -1) {
    executionIds[index].queryExecutionId[executionIdKey] = executionId;
  } else {
    // Create new group execution ids
    if (executionIds.length > NUMBER_SAVED_EXECUTION_ID_GROUP) {
      // Remove oldest group
      executionIds.shift();
    }

    // Create and push new group to the end of list
    executionIds.push({ queryKey, queryExecutionId: { [executionIdKey]: executionId } });
  }

  console.log('Updated execution ids:');
  console.log(executionIds);

  return executionIds;
};

/**
 * Find execution id
 *
 * @param  {string} queryKey       query key
 * @param  {string} executionIdKey query execution id key
 * @param  {array} executionIds    list of execution id
 *
 * @return {string}                execution id || empty string
 */
export const findExecutionId = (queryKey, executionIdKey, executionIds) => {
  const queryItem = _.find(executionIds, { queryKey });

  if (queryItem) {
    return _.get(queryItem, `queryExecutionId.${executionIdKey}`, '');
  }

  return '';
};
